import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ Component, children }) => {
  // console.log('🔒 ProtectedRoute rendering');
  // console.log('Component:', Component);
  // console.log('children:', children);
  
  const { isAuthenticated, loading } = useAuth();

  // console.log('isAuthenticated:', isAuthenticated);
  // console.log('loading:', loading);

  if (loading) {
    return (
      <div style={{ padding: '50px', backgroundColor: 'lightblue' }}>
        <h1>Loading...</h1>
      </div>
    );
  }

  if (!isAuthenticated) {
    // console.log('❌ Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // console.log('✅ Authenticated, rendering content');
  
  // If Component is passed as a prop
  if (Component) {
    return <Component />;
  }
  
  // If children are passed
  return children;
};

export default ProtectedRoute;